module.exports = {
          srcSet: __webpack_public_path__ + "public/images/0ea31739153d96d59b4ebda4e289e822-1774.webp"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/0ea31739153d96d59b4ebda4e289e822-1774.webp",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/0ea31739153d96d59b4ebda4e289e822-1774.webp",
          toString:function(){return __webpack_public_path__ + "public/images/0ea31739153d96d59b4ebda4e289e822-1774.webp"},
          
          width: 1774,
          height: 887
        }